export const MEMOINDEX = {
  header: 23,
  description: 24,
  team: 25,
  teamPhoto: 26,
  problemSolution: 27,
  tokenInfo: 28,
  tokenUtility: 29,
  traction: 30,
  backers: 31,
  competitiveEdge: 32,
  analysis: 33,
  opportunitiesRisks: 34,
};
